import Analytics from 'src/tracking/analytics';

export const trackButtonClick = ({ button, from }) =>
  Analytics.track('SMSF Landing Page Interaction', {
    button,
    from,
  });
